










import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    globalToLocalURL
} from "../utils/common";
import {
    pageDataType
} from "../types";

@Component({
    name: "newstab",
    components: {

    }
})
export default class NewsTab extends Vue {
    @Prop() items!: pageDataType[];
    globalToLocalURL: any = globalToLocalURL;
}
